import React, { useEffect } from "react"
import { Flex, Box } from "@rebass/grid/emotion"
import styled from "@emotion/styled"
import popupHelper from "@nutrafol/popup-helper"

import theme from "@nutrafol/nutrafol-ui-kit/styles/theme"
import { TextElement } from "@nutrafol/nutrafol-ui-kit/dist/TextElement"
import InfoIcon from "../../../../assets/icons/wild/info-icon-filled.svg"
import CloseIcon from "../../../../assets/icons/close-x-icon.svg"
import { queries } from "@nutrafol/nutrafol-ui-kit/styles/mediaqueries"

const ModalHeader = styled.div`
  background: linear-gradient(
    180deg,
    #ffffff 66.83%,
    rgba(255, 255, 255, 0) 100%
  );
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  padding: 16px;
  flex-wrap: wrap;
  align-items: center;
  z-index: 1;
  ${queries.medium`
    // padding: 44px 70px 44px 80px;
    padding: 32px 70px 32px 80px;
    width: calc(100% - 20px);
    left: 0px;
  `}
`

const ModalBody = styled.div`
  padding-top: 64px;
  padding-bottom: 85px; // mobile browser bar
  background: ${theme.color.white};
  height: 100vh;
  overflow-y: scroll;

  ${queries.medium`
    height: calc(100% - 32px);
    padding: 104px 72px 36px 80px;
    margin-top: 16px;
    margin-bottom: 16px;
    margin-right: 8px;
    &:not(.no-scrollbar) {
      &::-webkit-scrollbar {
        width: 8px;
        border-right: 8px solid #fff;
      }
      &::-webkit-scrollbar-track {
        border-radius: 8px;
        background: rgba(200, 210, 209, 1);
        box-shadow: 0px 10px 15px 0px rgba(0, 0, 0, 0.04);
        box-shadow: 0px 6px 10px 0px rgba(0, 0, 0, 0.02);
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.04);
      }
      &::-webkit-scrollbar-thumb {
        background: ${theme.wild.color.master.primary.default};
        border-radius: 8px;
      }
    }
  `}
`

const IconWrap = styled.div``

const WhatsInside = styled(Box)``

const CloseWrapper = styled.button`
  background: ${theme.color.white};
  border-radius: 50%;
  height: 32px;
  width: 32px;
  box-shadow:
    0 0 20px rgba(0, 0, 0, 0.05),
    0 24px 38px rgba(0, 0, 0, 0.03),
    0 9px 46px rgba(0, 0, 0, 0.03),
    0 11px 15px rgba(0, 0, 0, 0.03);
  align-self: flex-end;
  svg {
    display: block;
    margin: 0 auto;
    height: 10px;
    width: 10px;
  }
`

export const ModalWildAlt = (props) => {
  const Component = props.component
  const {
    hideModal,
    propsObject,
    modalSize,
    customZIndex,
    name,
    modalHeading,
    closeOnOverlayClick = true,
    closeOnEscape = true,
    noCustomScroll,
  } = props
  const zIndex = customZIndex ? customZIndex : 15

  const ModalOverlay = styled.div`
    position: fixed;
    z-index: ${zIndex};
    background: rgba(0, 87, 82, 0.2);
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
  `
  const ModalWrap = styled.div`
    position: fixed;
    z-index: ${zIndex + 1};
    left: 0;
    top: 0;
    width: 100%;
    height: auto;
    background: transparent;
    overflow: auto;
    ${queries.medium`
      background: ${theme.color.white};
      top: 10%;
      left: 50%;
      transform: translateX(-50%);
      width: 90%;
      height: 80vh;
      max-height: 750px;
      max-width: ${modalSize === "large" ? "990px" : "785px"};
      border-radius: 8px;
      box-shadow: 0 80px 67px rgba(13, 98, 92, 0.07), 0 30px 30px rgba(13, 98, 92, 0.05);
    `}   
  }
  `

  const hideModalProxy = () => {
    popupHelper.onClose()
    hideModal()
  }

  useEffect(() => {
    popupHelper.onOpen({
      closeOnEscape,
      wrapper: "Modal",
      desktopEl: "ModalBody",
      mobileEl: "ModalBody",
      closeEl: "CloseWrapper",
    })
    popupHelper.disableScroll()
  }, [])

  return (
    <>
      <ModalOverlay onClick={() => closeOnOverlayClick && hideModalProxy()} />
      <ModalWrap id={`Modal`} className={modalSize ? modalSize : ""}>
        <ModalHeader className="modal-header">
          <Flex flexWrap="wrap">
            <WhatsInside flex="1">
              <Flex flexWrap="wrap" height="100%" alignItems="center">
                <Box width={"24px"}>
                  <IconWrap>
                    <InfoIcon />
                  </IconWrap>
                </Box>
                <Box flex="1">
                  {name && (
                    <TextElement
                      text={`What's inside <span class='font-dinamoBold'>${name}</span>`}
                      element="p"
                      className="body--regular text-master-base-black"
                    />
                  )}
                  {modalHeading && (
                    <>
                      <TextElement
                        text={modalHeading}
                        element="p"
                        className="body--large-b text-master-base-black"
                      />
                    </>
                  )}
                </Box>
              </Flex>
            </WhatsInside>
            <Box width={"32px"}>
              <CloseWrapper id={`CloseWrapper`} onClick={hideModalProxy}>
                <CloseIcon />
              </CloseWrapper>
            </Box>
          </Flex>
        </ModalHeader>
        <ModalBody
          id={`ModalBody`}
          className={noCustomScroll ? "no-scrollbar" : ""}
        >
          <Component {...propsObject} hideModal={hideModalProxy} />
        </ModalBody>
      </ModalWrap>
    </>
  )
}

export default ModalWildAlt
